import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-800 text-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Left: Brand & Company Info */}
          <div className="flex flex-col gap-6">
            <Link to="/" className="cursor-pointer">
              <img
                src="https://storage.readdy-site.link/project_files/d7d29402-29c9-4a04-95fb-46dc6629671e/3729bbb1-4e17-4f2d-a1c0-8e0a08152d3a_compressed_CleanShot-2026-07-03-at-19.30.432x.webp"
                alt="株式会社ヴェリテ"
                className="h-14 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <div className="space-y-2 text-sm">
              <p className="font-semibold text-background-50">株式会社ヴェリテ</p>
              <p className="text-primary-200">
                〒980-0802 宮城県仙台市青葉区二日町14-14<br />
                二日町ゲートビル2階
              </p>
              <div className="pt-2 space-y-1">
                <p className="text-primary-200">
                  TEL: <span className="text-background-50">022-211-5488</span>
                  <span className="text-primary-400 text-xs ml-2">平日 9:00〜18:00</span>
                </p>
                <p className="text-primary-200">
                  Mail: <span className="text-background-50">verite@frise.support</span>
                </p>
              </div>
            </div>
          </div>

          {/* Center: Links */}
          <div className="flex flex-col gap-8">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-primary-300 mb-4">
                ページ
              </h4>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer">
                  トップ
                </Link>
                <Link to="/services" className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer">
                  事業内容
                </Link>
                <Link to="/pricing" className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer">
                  料金の目安
                </Link>
                <Link to="/company" className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer">
                  会社概要
                </Link>
                <Link to="/contact" className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer">
                  お問い合わせ
                </Link>
              </div>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-primary-300 mb-4">
                FRISEグループ
              </h4>
              <p className="text-sm leading-relaxed text-primary-200 max-w-xs mb-2">
                地域で福祉・就労支援に取り組むグループ。ヴェリテはその一員として社会的価値の創造に貢献しています。
              </p>
              <a
                href="https://frise-group.co.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
              >
                frise-group.co.jp
                <i className="ri-external-link-line text-xs" />
              </a>
            </div>
          </div>

          {/* Right: Office Image */}
          <div className="flex flex-col gap-6">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-primary-300 mb-4">
                アクセス
              </h4>
              <div className="relative overflow-hidden rounded-lg aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20creative%20agency%20office%20interior%20with%20warm%20lighting%2C%20wooden%20furniture%20and%20green%20plants%2C%20cozy%20workspace%20atmosphere%2C%20soft%20natural%20light%20through%20windows%2C%20editorial%20photography%20with%20warm%20neutral%20tones&width=800&height=600&seq=verite-footer-office&orientation=landscape"
                  alt="株式会社ヴェリテ オフィス"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-primary-500/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-primary-300">
            &copy; {currentYear} 株式会社ヴェリテ
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-xs text-primary-300 hover:text-background-50 transition-colors cursor-pointer">
              プライバシーポリシー
            </Link>
            <Link to="/legal" className="text-xs text-primary-300 hover:text-background-50 transition-colors cursor-pointer">
              特定商取引法に基づく表記
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}